<template>
  <DialogCard>
    <template #title>
      Contact
    </template>
    <template #text>
      neuralike, Inc.<br>
      PO Box 20015<br>
      Palo Alto, California 94305<br>
      Phone: <a href="tel:+1-415-670-9501">(415) 670-9501</a><br>
      Email: <a
        href="mailto:contact@neuralike.com"
        target="_blank"
        rel="noopener noreferrer"
      >contact@neuralike.com</a>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeContactDialog',
  components: {
    DialogCard,
  },
};
</script>
